import React from 'react';

export const WebflowLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <path
        d="m24 4.515-7.658 14.97H9.149l3.205-6.204h-.144C9.566 16.713 5.621 18.973 0 19.485v-6.118s3.596-.213 5.71-2.435H0V4.515h6.417v5.278l.144-.001 2.622-5.277h4.854v5.244h.144l2.72-5.244H24Z"
        fill="#146EF5"
      />
    </svg>
  </div>
);
